import { Frame } from '@amzn/stencil-react-components/frame';
import {
  SideNav,
  SideNavItem,
  SideNavSection
} from '@amzn/stencil-react-components/side-nav';
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { PAGE_PATHS } from 'src/constants/Urls';
import { isTRDEnabledDomain } from 'src/pages/TRD/TRDUtils';
import { UrlUtils } from 'src/utils/UrlUtils';
import { isMapleMigratedDomain } from 'src/utils/commons/CommonUtils';

const SideNavItemLink = SideNavItem.withComponent(Link);
const LeftNavigationPanel = () => {
  const location = useLocation();
  const { domainId }: { domainId: string } = useParams();
  const usersPageLocation = UrlUtils.prepareUrl(PAGE_PATHS.USERS, domainId!);
  const userProfilesPageLocation = UrlUtils.prepareUrl(
    PAGE_PATHS.PROFILES,
    domainId!
  );
  const caseQueuesPageLocation = UrlUtils.prepareUrl(
    PAGE_PATHS.CASE_QUEUES,
    domainId!
  );
  const userGroupPageLocation = UrlUtils.prepareUrl(
    PAGE_PATHS.USER_GROUP,
    domainId
  );
  const trdPageLocation = UrlUtils.prepareUrl(PAGE_PATHS.TRD, domainId);
  const bulkCaseManagementLocation = UrlUtils.prepareUrl(
    PAGE_PATHS.BULK_CASE_MANAGEMENT,
    domainId
  );
  const isTRDEnabled = isTRDEnabledDomain(domainId);
  const isMapleMigrated = isMapleMigratedDomain(domainId);

  return (
    <Frame height={isTRDEnabled ? 400 : 280} titleText="">
      <SideNav>
        <SideNavSection label="Admin Entities">
          {!isMapleMigrated && (
            <SideNavItemLink
              to={usersPageLocation}
              isSelected={location.pathname === usersPageLocation}
            >
              Users
            </SideNavItemLink>
          )}
          <SideNavItemLink
            to={userProfilesPageLocation}
            isSelected={location.pathname === userProfilesPageLocation}
          >
            User Profiles
          </SideNavItemLink>
          {!isMapleMigrated && (
            <SideNavItemLink
              to={caseQueuesPageLocation}
              isSelected={location.pathname === caseQueuesPageLocation}
            >
              Case Queues
            </SideNavItemLink>
          )}
          <SideNavItemLink
            to={userGroupPageLocation}
            isSelected={location.pathname === userGroupPageLocation}
          >
            User Groups
          </SideNavItemLink>
          {isTRDEnabled && (
            <SideNavItemLink
              to={trdPageLocation}
              isSelected={location.pathname.startsWith(trdPageLocation)}
            >
              TRD Management
            </SideNavItemLink>
          )}
          <SideNavItemLink
            to={bulkCaseManagementLocation}
            isSelected={location.pathname === bulkCaseManagementLocation}
          >
            Bulk Case Management
          </SideNavItemLink>
        </SideNavSection>
      </SideNav>
    </Frame>
  );
};

export default LeftNavigationPanel;
